import React from 'react';
import { Pressable, Text, View } from 'react-native';
import i18n from './../util/i18n';
import { addSong, getSong, updateSong } from '../services/song.service';
import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, Grid2, InputLabel, MenuItem, Select, Stack, Switch, TextField } from '@mui/material';
import { getMovies, insertMovie } from '../services/movie.service';
import { getReleases, insertRelease } from '../services/release.service';
import { getArtists } from '../services/artist.service';
import { insertArtist } from '../services/artist.service';
import { convertHourMinuteSecondsToSeconds, convertSecondsToHourMinuteSeconds } from '../services/common.service';
import { getSetting } from '../services/settings.service';
import { playMusicSpotify, searchTracksSpotify, spotifyConnectionStatus } from '../services/spotify.service';
import { getLanguages } from '../services/language.service';
import { insertLanguage } from '../services/language.service';
import { deleteUploadedFile } from '../services/upload.service';

i18n.locale = navigator.language;

class AddEditSong extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            category_id: this?.props?.route?.params?.category || null,
            song_id: this?.props?.route?.params?.song || null,
            movies: [],
            releases: [],
            artists: [],
            languages: [],
            // payload
            sl_no: '',
            type: '',
            release: '',
            releaseId: '',
            movie: '',
            movieId: '',
            artist: '',
            artistId: '',
            langauge: '',
            languageId: '',
            audio_source: 'spotify_url',
            spotify_url: '',
            audio_file: null,
            cover_image: null,
            timeline: {
                song_start_time: '',
                jump_to_chorus: '',
                chorus_start_time: '',
                chorus_time: '',
                solution_display_time: ''
            },
            time: '',
            has_movie: false,
            movie_aliases: [],
            has_release: false,
            release_aliases: [],
            has_artist: false,
            artist_aliases: [],
            has_language: false,
            language_aliases: [],
            newMovieName: '',
            newMovieAliases: [],
            newReleaseName: '',
            newReleaseAliases: [],
            newArtistName: '',
            newArtistAliases: [],
            newLanguageName: '',
            newLanguageAliases: [],
            is_muted: false,
            // For music playing
            devices: [],
            device: ''
        };
    }

    setStateAsync = (state) => {
        return new Promise((resolve) => {
            this.setState(state, resolve);
        });
    }

    async componentDidMount() {
        this.populateMovies();
        this.populateReleases();
        this.populateArtists();
        this.populateLanguages();
        this.getSong();
        this.setDetaultTimeline();
        this.populateDevices();
    }

    populateMovies = async (search = '') => {

        let movies = [];

        try {
            let response = await getMovies({ search: search });
            if (response?.error) {
                alert('Error', response.error);
                return;
            }
            movies = response?.movies ? response.movies : [];

            movies = movies.map(movie => {
                return {
                    id: movie._id,
                    label: movie.name,
                    value: movie._id
                }
            })
        } catch (error) {
            console.log(error);
            movies = [];
        }
        this.setState({ movies: movies });
    }

    populateReleases = async (search = '') => {

        let releases = [];

        try {
            let response = await getReleases({ search: search });
            if (response?.error) {
                alert('Error', response.error);
                return;
            }
            releases = response?.releases ? response.releases : [];
            releases = releases.map(release => {
                return {
                    id: release._id,
                    label: release.title,
                    value: release._id
                }
            })
        } catch (error) {
            console.log(error);
            releases = [];
        }
        this.setState({ releases: releases });
    }

    populateArtists = async (search = '') => {

        let artists = [];

        try {
            let response = await getArtists({ search: search });
            if (response?.error) {
                alert('Error', response.error);
                return;
            }
            artists = response?.artists ? response.artists : [];
            artists = artists.map(artist => {
                return {
                    id: artist._id,
                    label: artist.name,
                    value: artist._id
                }
            })
        } catch (error) {
            console.log(error);
            artists = [];
        }
        
        this.setState({ artists: artists });

    }

    populateLanguages = async (search = '') => {

        let languages = [];

        try {
            let response = await getLanguages({ search: search });
            if (response?.error) {
                alert('Error', response.error);
                return;
            }
            languages = response?.languages ? response.languages : [];
            languages = languages.map(language => {
                return {
                    id: language._id,
                    label: language.name,
                    value: language._id
                }
            })
        } catch (error) {
            console.log(error);
            languages = [];
        }
        
        this.setState({ languages: languages });

    }

    populateSpotifyUrls = async (search = '') => {

        let spotify_urls = [];

        try {
            let response = await searchTracksSpotify({ q: search });
            if (response?.error) {
                alert('Error', response.error);
                return;
            }
            let tracks = response?.tracks?.items ? response.tracks.items : [];
            spotify_urls = tracks.map(track => {
                return {
                    id: track.id,
                    label: `${track.name} - ${track.artists.map(artist => artist.name).join(', ')}`,
                    value: track.external_urls.spotify
                }
            })
        } catch (error) {
            console.log(error);
            spotify_urls = [];
        }

        return this.setState({ spotify_urls: spotify_urls });
    }

    populateDevices = async () => {
        let spotifyConnectionStatusRes = await spotifyConnectionStatus();

        if (spotifyConnectionStatusRes?.error) {
            console.log("Error getting connection status " + spotifyConnectionStatusRes.error);
            return;
        }

        let devices = spotifyConnectionStatusRes?.devices || [];
        this.setState({
            devices: devices,
            device: devices?.[0]?.id
        });
    }

    getSong = async () => {
        if (this.state.song_id) {
            let song = await getSong(this.state.song_id);
            song = song.song;

            console.log("Audio File: ", song?.audio_file);

            await this.setStateAsync({
                sl_no: song?.sl_no ?? '',
                type: song?.type ?? '',
                release: song?.release?.title ?? '',
                releaseId: song?.release?._id ?? '',
                movie: song?.movie?.name ?? '',
                movieId: song?.movie?._id ?? '',
                artist: song?.artist?.name ?? '',
                artistId: song?.artist?._id ?? '',
                language: song?.language?.name ?? '',
                languageId: song?.language?._id ?? '',
                audio_source: song?.audio_source ?? 'spotify_url',
                spotify_url: song?.spotify_url ?? '',
                audio_file: song?.audio_file ?? null,
                cover_image: song?.cover_image ?? null,
                is_muted: song?.is_muted ?? false,
                timeline: {
                    song_start_time: await convertSecondsToHourMinuteSeconds(song?.timeline?.song_start_time),
                    jump_to_chorus: song?.timeline?.jump_to_chorus ?? '',
                    chorus_start_time: await convertSecondsToHourMinuteSeconds(song?.timeline?.chorus_start_time),
                    chorus_time: song?.timeline?.chorus_time ?? '',
                    solution_display_time: song?.timeline?.solution_display_time ?? ''
                },
                time: song?.time ?? '',
                movie_aliases: song?.movie_aliases || [],
                release_aliases: song?.release_aliases || [],
                artist_aliases: song?.artist_aliases || [],
                language_aliases: song?.language_aliases || [],
                has_movie: song?.has_movie || false,
                has_release: song?.has_release || false,
                has_artist: song?.has_artist || false,
                has_language: song?.has_language || false
            });
            this.onTimelineChange();

            this.populateMovies(song?.movie?.name ?? '');
            this.populateReleases(song?.release?.title ?? '');
            this.populateArtists(song?.artist?.name ?? '');
            this.populateLanguages(song?.language?.name ?? '');
        }
    }

    setDetaultTimeline = async () => {
        if (!this.state.song_id) {
            let default_timeline = await getSetting('timeline');
            if (default_timeline?.setting?.data) {
                let timeline_data = default_timeline.setting.data;
                await this.setStateAsync({
                    timeline: {
                        song_start_time: await convertSecondsToHourMinuteSeconds(timeline_data?.song_start_time || ''),
                        jump_to_chorus: timeline_data?.jump_to_chorus || '',
                        chorus_start_time: await convertSecondsToHourMinuteSeconds(timeline_data?.chorus_start_time || ''),
                        chorus_time: timeline_data?.chorus_time || '',
                        solution_display_time: timeline_data?.solution_display_time || ''
                    },
                    time: timeline_data?.time || ''
                });
                this.onTimelineChange();
            }
        }
    }

    saveSong = async (play = false) => {

        let payload = {
            category: this.state.category_id,
            sl_no: this.state.sl_no,
            type: this.state.type,
            release: this.state.has_release ? (this.state?.releaseId ?? null) : null,
            movie: this.state.has_movie ? (this.state?.movieId ?? null) : null,
            artist: this.state.has_artist ? (this.state?.artistId ?? null) : null,
            language: this.state.has_language ? (this.state?.languageId ?? null) : null,
            audio_source: this.state?.audio_source ?? 'spotify_url',
            spotify_url: this.state?.spotify_url ?? '',
            audio_file: this.state?.audio_file ?? null,
            cover_image: this.state?.cover_image ?? null,
            is_muted: this.state?.is_muted ?? false,
            timeline: {
                song_start_time: await convertHourMinuteSecondsToSeconds(this.state?.timeline?.song_start_time),
                jump_to_chorus: await convertHourMinuteSecondsToSeconds(this.state?.timeline?.jump_to_chorus),
                chorus_start_time: await convertHourMinuteSecondsToSeconds(this.state?.timeline?.chorus_start_time),
                chorus_time: await convertHourMinuteSecondsToSeconds(this.state?.timeline?.chorus_time),
                solution_display_time: await convertHourMinuteSecondsToSeconds(this.state?.timeline?.solution_display_time)
            },
            time: this.state?.time ?? '',
            has_movie: this.state?.has_movie ?? false,
            movie_aliases: this.state?.movie_aliases ?? [],
            has_release: this.state?.has_release ?? false,
            release_aliases: this.state?.release_aliases ?? [],
            has_artist: this.state?.has_artist ?? false,
            artist_aliases: this.state?.artist_aliases ?? [],
            has_language: this.state?.has_language ?? false,
            language_aliases: this.state?.language_aliases ?? []
        }
        
        let response;
        if (this.state.song_id) {
            response = await updateSong(this.state.song_id, payload);
        } else {
            response = await addSong(payload);
        }

        if (response?.error) {
            alert(response.error);
            return false;
        }

        if (play) {
            let playRes = await playMusicSpotify({
                device_id: this.state.device,
                song_id: response?.song?._id
            })
            if (playRes?.error) {
                alert("Error playing music " + playRes.error);
                return true;
            }
        }

        return true;
    }


    //add movie
    addMovie = async (movieData) => {
        let response = await insertMovie(movieData);
        if (response?.error) {
            alert(response.error);
            return false;
        }
        return response.movie;
    }

    //add release
    addRelease = async (releaseData) => {
        let response = await insertRelease(releaseData);
        if (response?.error) {
            alert(response.error);
            return false;
        }
        return response.release;
    }

    //add artist
    addArtist = async (artistData) => {
        let response = await insertArtist(artistData);
        if (response?.error) {
            alert(response.error);
            return false;
        }
        return response.artist;
    }

    //add language
    addLanguage = async (languageData) => {
        let response = await insertLanguage(languageData);
        if (response?.error) {
            alert(response.error);
            return false;
        }
        return response.language;
    }

    onTimelineChange = async () => {
        // let song_start_time = await convertHourMinuteSecondsToSeconds(this.state?.timeline?.song_start_time);
        let jump_to_chorus = await convertHourMinuteSecondsToSeconds(this.state?.timeline?.jump_to_chorus);
        jump_to_chorus = isNaN(jump_to_chorus) ? 0 : Math.max(0, jump_to_chorus);

        // let total_time = jump_to_chorus + chorus_time;
        let time = await convertHourMinuteSecondsToSeconds(this.state?.time);

        let chorus_time = time - jump_to_chorus;
        chorus_time = isNaN(chorus_time) ? 0 : Math.max(0, chorus_time);

        this.setState({ timeline: {
            ...this.state.timeline,
            chorus_time: chorus_time
        }});
    }

    render() {
        return (
            <View>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                    <Text style={{ padding: 10, fontSize: 25 }}>
                        {this.state.song_id ? i18n.t('edit_song') : i18n.t('add_song')}
                    </Text>
                </View>

                <Grid2 container sx={{ marginTop: 2 }}>
                    <Stack spacing={2} style={{ width: '100%' }}>
                        <TextField
                            fullWidth
                            size='small'
                            placeholder={i18n.t('position')}
                            label={i18n.t('position')}
                            value={this.state.sl_no}
                            onChange={(e) => {
                                this.setState({ sl_no: e.target.value });
                            }}
                            onBlur={() => {
                                // convert to integer
                                let sl_no = parseInt(this.state.sl_no);
                                if (isNaN(sl_no)) {
                                    this.setState({ sl_no: '' });
                                    return;
                                }
                                this.setState({ sl_no: sl_no });
                            }}
                        />

                        <TextField
                            fullWidth
                            size='small'
                            placeholder={i18n.t('type')}
                            label={i18n.t('type')}
                            value={this.state.type}
                            onChange={(e) => {
                                this.setState({ type: e.target.value });
                            }}
                        />


                        <Stack spacing={2} direction={'row'}>
                            {/* Checkbox */}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.has_movie}
                                        onChange={(event) => {
                                            this.setState({ has_movie: event.target.checked });
                                        }}
                                    />
                                }
                                label={i18n.t('has_movie')}
                            />
                            {(this.state.has_movie) ? (
                                <>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    disablePortal
                                    id="movie-select"
                                    options={this.state.movies || []}
                                    renderInput={(params) => <TextField {...params} inputRef={this.movieRef} label={i18n.t('movie_name')}/>}
                                    onInputChange={(event, value) => {
                                        clearTimeout(this.timeoutId);
                                        this.timeoutId = setTimeout(() => {
                                            this.populateMovies(value);
                                        }, 500);
                                    }}
                                    value={this.state.movie}
                                    onChange={async (event, value, reason) => {
                                        if (value && value.inputValue) {
                                            const newMovie = await this.addMovie({ name: value.inputValue, aliases: this.state.movie_aliases || [] });
                                            if (newMovie && newMovie._id) {
                                                this.setState({ movie: newMovie.name, movieId: newMovie._id });
                                            } else {
                                                // If there was an error adding the movie, clear the input
                                                this.setState({ movie: '', movieId: '' });
                                            }
                                        } else if (value && value.value && value.label) {
                                            this.setState({ movie: value.label, movieId: value.value });
                                        } else if (reason === 'clear') {
                                            this.setState({ movie: '', movieId: '' });
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value || option.label === value?.label;
                                    }}
                                    filterOptions={(options, state) => {
                                        const filtered = [...options];
                                        const inputValue = state.inputValue;
                                        if (inputValue !== '') {
                                            filtered.push({ inputValue, label: `Add "${inputValue}"` });
                                        }
                                        return filtered;
                                    }}
                                />
                                <Autocomplete
                                    fullWidth
                                    multiple
                                    freeSolo
                                    size='small'
                                    id="movie_aliases"
                                    disableClearable
                                    options={[]}
                                    value={this.state.movie_aliases}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size='small'
                                            label={i18n.t('movie_aliases')}
                                            placeholder={i18n.t('movie_aliases')}
                                            slotProps={{
                                                input: {
                                                    ...params.InputProps,
                                                    type: 'search',
                                                },
                                            }}
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        this.setState({ movie_aliases: value });
                                    }}
                                />
                                </>
                            ) : null}
                        </Stack>

                        <Stack spacing={2} direction={'row'}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.has_release}
                                        onChange={(event) => {
                                            this.setState({ has_release: event.target.checked });
                                        }}
                                    />
                                }
                                label={i18n.t('has_release')}
                            />
                            {(this.state.has_release) ? (
                                <>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    disablePortal
                                    id="release-select"
                                    options={this.state.releases || []}
                                    renderInput={(params) => <TextField {...params} inputRef={this.releaseRef} label={i18n.t('song_name')}/>}
                                    onInputChange={(event, value) => {
                                        clearTimeout(this.timeoutId);
                                        this.timeoutId = setTimeout(() => {
                                            this.populateReleases(value);
                                        }, 500);
                                    }}
                                    value={this.state.release}
                                    onChange={async (event, value, reason) => {
                                        if (value && value.inputValue) {
                                            const newRelease = await this.addRelease({ title: value.inputValue, aliases: this.state.movie_aliases || [] });
                                            if (newRelease && newRelease._id) {
                                                this.setState({ release: newRelease.title, releaseId: newRelease._id });
                                            } else {
                                                // If there was an error adding the release, clear the input
                                                this.setState({ release: '', releaseId: '' });
                                            }
                                        } else if (value && value.value && value.label) {
                                            this.setState({ release: value.label, releaseId: value.value });
                                        } else if (reason === 'clear') {
                                            this.setState({ release: '', releaseId: '' });
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value || option.label === value?.label;
                                    }}
                                    filterOptions={(options, state) => {
                                        const filtered = [...options];
                                        const inputValue = state.inputValue;
                                        if (inputValue !== '') {
                                            filtered.push({ inputValue, label: `Add "${inputValue}"` });
                                        }
                                        return filtered;
                                    }}
                                />
                                <Autocomplete
                                    fullWidth
                                    multiple
                                    freeSolo
                                    size='small'
                                    id="release_aliases"
                                    disableClearable
                                    options={[]}
                                    value={this.state.release_aliases}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size='small'
                                            label={i18n.t('release_aliases')}
                                            placeholder={i18n.t('release_aliases')}
                                            slotProps={{
                                                input: {
                                                    ...params.InputProps,
                                                    type: 'search',
                                                },
                                            }}
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        this.setState({ release_aliases: value });
                                    }}
                                />
                                </>
                            ) : null}
                        </Stack>

                        <Stack spacing={2} direction={'row'}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.has_artist}
                                        onChange={(event) => {
                                            this.setState({ has_artist: event.target.checked });
                                        }}
                                    />
                                }
                                label={i18n.t('has_artist')}
                            />
                            {(this.state.has_artist) ? (
                                <>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    disablePortal
                                    id="artist-select"
                                    options={this.state.artists || []}
                                    renderInput={(params) => <TextField {...params} inputRef={this.artistRef} label={i18n.t('artist_name')} />}
                                    onInputChange={(event, value) => {
                                        clearTimeout(this.timeoutId);
                                        this.timeoutId = setTimeout(() => {
                                            this.populateArtists(value);
                                        }, 500);
                                    }}
                                    value={this.state.artist}
                                    onChange={async (event, value, reason) => {
                                        if (value && value.inputValue) {
                                            const newArtist = await this.addArtist({ name: value.inputValue, aliases: this.state.artist_aliases || [] });
                                            if (newArtist && newArtist._id) {
                                                this.setState({ artist: newArtist.name, artistId: newArtist._id });
                                            } else {
                                                // If there was an error adding the artist, clear the input
                                                this.setState({ artist: '', artistId: '' });
                                            }
                                        } else if (value && value.value && value.label) {
                                            this.setState({ artist: value.label, artistId: value.value });
                                        } else if (reason === 'clear') {
                                            this.setState({ artist: '', artistId: '' });
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value || option.label === value?.label;
                                    }}
                                    filterOptions={(options, state) => {
                                        const filtered = [...options];
                                        const inputValue = state.inputValue;
                                        if (inputValue !== '') {
                                            filtered.push({ inputValue, label: `Add "${inputValue}"` });
                                        }
                                        return filtered;
                                    }}
                                />
                                <Autocomplete
                                    fullWidth
                                    multiple
                                    freeSolo
                                    size='small'
                                    id="artist_aliases"
                                    disableClearable
                                    options={[]}
                                    value={this.state.artist_aliases}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size='small'
                                            label={i18n.t('artist_aliases')}
                                            placeholder={i18n.t('artist_aliases')}
                                            slotProps={{
                                                input: {
                                                    ...params.InputProps,
                                                    type: 'search',
                                                },
                                            }}
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        this.setState({ artist_aliases: value });
                                    }}
                                />
                                </>
                            ) : null}
                        </Stack>

                        <Stack spacing={2} direction={'row'}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.has_language}
                                        onChange={(event) => {
                                            this.setState({ has_language: event.target.checked });
                                        }}
                                    />
                                }
                                label={i18n.t('has_language')}
                            />
                            {(this.state.has_language) ? (
                                <>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    disablePortal
                                    id="language-select"
                                    options={this.state.languages || [{ label: this.state.language, value: this.state.languageId }]}
                                    renderInput={(params) => <TextField {...params} inputRef={this.languageRef} label={i18n.t('language')} />}
                                    onInputChange={(event, value) => {
                                        clearTimeout(this.timeoutId);
                                        this.timeoutId = setTimeout(() => {
                                            this.populateLanguages(value);
                                        }, 500);
                                    }}
                                    value={this.state.language}
                                    onChange={async (event, value, reason) => {
                                        if (value && value.inputValue) {
                                            const newLanguage = await this.addLanguage({ name: value.inputValue, aliases: this.state.language_aliases || [] });
                                            if (newLanguage && newLanguage._id) {
                                                this.setState({ language: newLanguage.name, languageId: newLanguage._id });
                                            } else {
                                                // If there was an error adding the language, clear the input
                                                this.setState({ language: '', languageId: '' });
                                            }
                                        } else if (value && value.label) {
                                            this.setState({ language: value.label, languageId: value.value });
                                        } else if (reason === 'clear') {
                                            this.setState({ language: '', languageId: '' });
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value || option.label === value?.label;
                                    }}
                                    filterOptions={(options, state) => {
                                        const filtered = [...options];
                                        const inputValue = state.inputValue;
                                        if (inputValue !== '') {
                                            filtered.push({ inputValue, label: `Add "${inputValue}"` });
                                        }
                                        return filtered;
                                    }}
                                />
                                <Autocomplete
                                    fullWidth
                                    multiple
                                    freeSolo
                                    size='small'
                                    id="language_aliases"
                                    disableClearable
                                    options={[]}
                                    value={this.state.language_aliases}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size='small'
                                            label={i18n.t('language_aliases')}
                                            placeholder={i18n.t('language_aliases')}
                                            slotProps={{
                                                input: {
                                                    ...params.InputProps,
                                                    type: 'search',
                                                },
                                            }}
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        this.setState({ language_aliases: value });
                                    }}
                                />
                                </>
                            ) : null}
                        </Stack>

                        {/* Dropdown - audio_source -> spotify_url, audio_upload */}
                        <FormControl fullWidth>
                            <InputLabel id="audio-source-label">{i18n.t('audio_source')}</InputLabel>
                            <Select
                                labelId="audio-source-label"
                                fullWidth
                                size='small'
                                value={this.state.audio_source}
                                label={i18n.t('audio_source')}
                                onChange={(e) => {
                                    this.setState({ audio_source: e.target.value });
                                }}
                            >
                                <MenuItem value={'spotify_url'}>{i18n.t('spotify_url')}</MenuItem>
                                <MenuItem value={'audio_upload'}>{i18n.t('audio_upload')}</MenuItem>
                            </Select>
                        </FormControl>


                        {(this.state.audio_source === 'spotify_url') && (
                            <Autocomplete
                                fullWidth
                                size='small'
                                disablePortal
                                id="spotify-url-select"
                                options={this.state.spotify_urls || []}
                                renderInput={(params) => <TextField {...params} inputRef={this.spotifyUrlRef} label={i18n.t('spotify_url')}/>}
                                onInputChange={(event, value) => {
                                    clearTimeout(this.timeoutId);
                                    this.timeoutId = setTimeout(() => {
                                        this.populateSpotifyUrls(value);
                                    }, 500);
                                }}
                                value={this.state.spotify_url}
                                onChange={(event, value, reason) => {
                                    if (value && value.inputValue) {
                                        // Show typed text in input and dropdown even after clicking away
                                        this.setState({ spotify_url: value.inputValue });
                                    } else if (typeof value === 'string') {
                                        this.setState({ spotify_url: value });
                                    } else if (value && value.value && value.label) {
                                        this.setState({ spotify_url: value.value });
                                    } else if (value && value.label) {
                                        this.setState({ spotify_url: value.label });
                                    } else if (reason === 'clear') {
                                        this.setState({ spotify_url: '' });
                                    }
                                }}
                                onBlur={(e) => {
                                    let spotify_url = e.target.value;
                                    if (spotify_url.includes('?')) {
                                        spotify_url = spotify_url.split('?')[0];
                                    }
                                    this.setState({ spotify_url });
                                }}
                                isOptionEqualToValue={(option, value) => {
                                    return option.label === value || option.label === value?.label;
                                }}
                                filterOptions={(options, state) => {
                                    const filtered = [...options];
                                    const inputValue = state.inputValue;
                                    if (inputValue !== '') {
                                        filtered.push({ inputValue, label: `Add "${inputValue}"` });
                                    }
                                    return filtered;
                                }}
                            />
                        )}

                        {(this.state.audio_source === 'audio_upload') ? (
                            <>
                                {!this.state.audio_file ? (
                                    <Button
                                        variant="contained"
                                        component="label"
                                        fullWidth
                                    >
                                        {i18n.t('upload_audio')}
                                        <input
                                            type="file"
                                            accept="audio/*"
                                            hidden
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    this.setState({ audio_file: file });
                                                }
                                            }}
                                        />
                                    </Button>
                                ) : (
                                    <>
                                        {this.state.audio_file.name ? (
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => {

                                                    // confirm
                                                    let c = confirm(i18n.t('are_you_sure_you_want_to_remove_audio_file') + ": " + this.state.audio_file.name + "?");
                                                    if (!c) return;

                                                    this.setState({ audio_file: null });
                                                }}
                                            >
                                                {this.state.audio_file.name} - {i18n.t('remove')}
                                            </Button>
                                        ) : null}
                                    </>
                                )}

                                {(this.state.audio_file?.path) ? (
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={async () => {

                                            // confirm
                                            let c = confirm(i18n.t('are_you_sure_you_want_to_remove_audio_file') + ": " + this.state.audio_file.originalname + "?");
                                            if (!c) return;

                                            let response = await deleteUploadedFile({ filePath: this.state.audio_file.path });
                                            if (response?.error) {
                                                if(confirm(i18n.t('error_deleting_uploaded_file') + ": " + response.error + ". " + i18n.t('do_you_want_to_remove_audio_file_link_from_song'))) {
                                                    this.setState({ audio_file: null });
                                                }
                                                return;
                                            }
                                            this.setState({ audio_file: null });
                                        }}
                                    >
                                        {this.state.audio_file.originalname} - {i18n.t('remove')}
                                    </Button>
                                ) : null}
                            </>
                        ) : null}


                        {!this.state.cover_image ? (
                            <Button
                                variant="contained"
                                component="label"
                                fullWidth
                            >
                                {i18n.t('upload_cover_image')}
                                <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            this.setState({ cover_image: file });
                                        }
                                    }}
                                />
                            </Button>
                        ) : (
                            <>
                                {this.state.cover_image.name ? (
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => {

                                            // confirm
                                            let c = confirm(i18n.t('are_you_sure_you_want_to_remove_cover_image') + ": " + this.state.cover_image.name + "?");
                                            if (!c) return;

                                            this.setState({ cover_image: null });
                                        }}
                                    >
                                        {this.state.cover_image.name} - {i18n.t('remove')}
                                    </Button>
                                ) : null}
                            </>
                        )}

                        {(this.state.cover_image?.path) ? (
                            <Button
                                variant="contained"
                                color="error"
                                onClick={async () => {

                                    // confirm
                                    let c = confirm(i18n.t('are_you_sure_you_want_to_remove_cover_image') + ": " + this.state.cover_image.originalname + "?");
                                    if (!c) return;

                                    let response = await deleteUploadedFile({ filePath: this.state.cover_image.path });
                                    if (response?.error) {
                                        if(confirm(i18n.t('error_deleting_uploaded_file') + ": " + response.error + ". " + i18n.t('do_you_want_to_remove_cover_image_link_from_song'))) {
                                            this.setState({ cover_image: null });
                                        }
                                        return;
                                    }
                                    this.setState({ cover_image: null });
                                }}
                            >
                                {this.state.cover_image.originalname} - {i18n.t('remove')}
                            </Button>
                        ) : null}

                        <FormControlLabel
                            control={<Switch
                                checked={this.state.is_muted}
                                onChange={(e) => {
                                    this.setState({ is_muted: e.target.checked });
                                }}
                            />}
                            label={i18n.t('is_muted')}
                        />

                        {/* Timeline */}
                        <Stack spacing={2}>
                            {/* Label */}
                            <Text>{i18n.t('timeline')}</Text>
                            <TextField
                                fullWidth
                                size='small'
                                placeholder={i18n.t('song_start_time') + ` (${i18n.t('in_mm_ss_format')})`}
                                label={i18n.t('song_start_time') + ` (${i18n.t('in_mm_ss_format')})`}
                                value={this.state.timeline.song_start_time}
                                onChange={async (e) => {
                                    await this.setStateAsync({ timeline: { ...this.state.timeline, song_start_time: e.target.value } });
                                    this.onTimelineChange();
                                }}
                                helperText={i18n.t('song_start_time_helper_text')}
                            />
                            <TextField
                                fullWidth
                                size='small'
                                placeholder={i18n.t('jump_to_chorus') + ` (${i18n.t('in_seconds')})`}
                                label={i18n.t('jump_to_chorus') + ` (${i18n.t('in_seconds')})`}
                                value={this.state.timeline.jump_to_chorus}
                                onChange={async (e) => {
                                    await this.setStateAsync({ timeline: { ...this.state.timeline, jump_to_chorus: e.target.value } });
                                    this.onTimelineChange();
                                }}
                                helperText={i18n.t('jump_to_chorus_helper_text')}
                            />
                            <TextField
                                fullWidth
                                size='small'
                                placeholder={i18n.t('chorus_start_time') + ` (${i18n.t('in_mm_ss_format')})`}
                                label={i18n.t('chorus_start_time') + ` (${i18n.t('in_mm_ss_format')})`}
                                value={this.state.timeline.chorus_start_time}
                                disabled={parseInt(this.state.timeline.jump_to_chorus) <= 0}
                                onChange={async (e) => {
                                    await this.setStateAsync({ timeline: { ...this.state.timeline, chorus_start_time: e.target.value } });
                                    this.onTimelineChange();
                                }}
                                helperText={i18n.t('chorus_start_time_helper_text')}
                            />
                            {/* <TextField
                                disabled
                                fullWidth
                                size='small'
                                placeholder={i18n.t('chorus_time') + ` (${i18n.t('in_seconds')})`}
                                label={i18n.t('chorus_time') + ` (${i18n.t('in_seconds')})`}
                                value={this.state.timeline.chorus_time}
                                onChange={async (e) => {
                                    await this.setStateAsync({ timeline: { ...this.state.timeline, chorus_time: e.target.value } });
                                    this.onTimelineChange();
                                }}
                                helperText={i18n.t('chorus_time_helper_text')}
                            /> */}
                            <TextField
                                fullWidth
                                size='small'
                                placeholder={i18n.t('time') + ` (${i18n.t('in_seconds')})`}
                                label={i18n.t('time') + ` (${i18n.t('in_seconds')})`}
                                value={this.state.time}
                                onChange={async (e) => {
                                    // this.setState({ time: e.target.value });
                                    await this.setStateAsync({ time: e.target.value });
                                    this.onTimelineChange();
                                }}
                                helperText={i18n.t('time_helper_text')}
                            />
                            <TextField
                                fullWidth
                                size='small'
                                placeholder={i18n.t('solution_display_time') + ` (${i18n.t('in_seconds')})`}
                                label={i18n.t('solution_display_time') + ` (${i18n.t('in_seconds')})`}
                                value={this.state.timeline.solution_display_time}
                                onChange={async (e) => {
                                    await this.setStateAsync({ timeline: { ...this.state.timeline, solution_display_time: e.target.value } });
                                    this.onTimelineChange();
                                }}
                                helperText={i18n.t('solution_display_time_helper_text')}
                            />
                            
                        </Stack>

                        
                    </Stack>
                </Grid2>

                <Grid2 container sx={{ marginTop: 2 }}>
                    <Stack spacing={2} direction={'row'} style={{ width: '100%' }}>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: 'gray', flex: 1 }}
                            onClick={() => {
                                this.props.navigation.navigate('Songs', { category: this.state.category_id });
                            }}
                        >
                            {i18n.t('cancel')} / {i18n.t('go_back')}
                        </Button>
                        <Button
                            variant="contained"
                            style={{ flex: 1 }}
                            onClick={async () => {
                                let response = await this.saveSong();
                                if (response)
                                    this.props.navigation.navigate('Songs', { category: this.state.category_id });
                            }}
                        >
                            {i18n.t('save')}
                        </Button>
                        <Button
                            variant="contained"
                            style={{ flex: 1 }}
                            onClick={async () => {
                                await this.saveSong(true);
                            }}
                        >
                            {i18n.t('save_and_play')}
                        </Button>
                    </Stack>
                </Grid2>
                
                
            </View>
        )
    }
}

export default AddEditSong;
